export default "__VITE_ASSET__ip27nNQQ__"